import CommandCard from '@/components/client/command-card';
import type { IClientAction } from '@/entities/client.entity';
import { TerminalIcon } from 'lucide-react';

interface ClientCommandsListProps {
	actions: IClientAction[];
	onCopy: (text: string) => void;
}

export default function ClientCommandsList({ actions, onCopy }: ClientCommandsListProps) {
	if (!actions.length) {
		return (
			<div className='flex flex-col items-center justify-center mt-10 gap-2 px-4 text-center'>
				<TerminalIcon size={24} className='text-muted-foreground/40' />
				<p className='text-sm text-muted-foreground'>Команд нет</p>
			</div>
		);
	}

	return (
		<div className='flex flex-col gap-1.5 px-2'>
			{actions.map(action => (
				<CommandCard key={action.id} action={action} onCopy={onCopy} />
			))}
		</div>
	);
}
